module.exports = __webpack_public_path__ + "assets/img/solar-panels-8.4acb4b47.jpg";